export type ColumnTitleDateProps = {
  title: string;
  date: string;
};

const ColumnTitleDate: React.FC<ColumnTitleDateProps> = ({ title, date }) => {
  const formattedDate = new Date(date)
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .join("-");
  return (
    <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500 min-w-60">
      <div className="text-gray-900">{title}</div>
      <div className="mt-1 text-gray-500">{formattedDate}</div>
    </td>
  );
};

export default ColumnTitleDate;
